<div class="form-group">
  <label
    [translatable]="{
      transKey: titleTranslationKey,
      modEnum: titleTranslationModuleEnum
    }"
    class="form-label"
  >
    {{ title }}
    <span *ngIf="IsCommentRequired" class="astrix-red">*</span>
  </label>
  <div class="input-wrapper">
    <div
      *ngIf="isTitle"
      style="width: 100%"
      [translatable]="{
        transKey: 'shared.typeDescription',
        modEnum: translationModulesEnum.shared
      }"
    >
      <textarea
        (input)="change()"
        [disabled]="disabled"
        [(ngModel)]="value"
        [placeholder]="'shared.typeDescription' | translate"
        class="form-textarea"
        [ngClass]="{ valid: control.valid }"
        *ngIf="isTitle"
      ></textarea>
    </div>
    <ul class="uploaded-files sdfdf" *ngIf="uploadedFiles.length !== 0">
      <li *ngFor="let file of uploadedFiles; let i = index">
        <div class="file-details">
          <i [class]="'bx ' + 'bxs-file-' + file?.extension"></i>
          <div>
            <span class="name" [title]="file?.name">{{
              file?.name.length > 25
                ? file?.name?.slice(0, 25).concat("...")
                : file?.name
            }}</span>

            <span class="size">{{ file?.size }}MB</span>
          </div>
        </div>
        <button (click)="onDeleteFile(i)" class="file-delete-btn">
          <i class="bx bx-trash"></i>
        </button>
        <button (click)="onViewLocalFile(i)" class="file-view-btn">
          <i class="bx bx-show"></i>
        </button>
      </li>
    </ul>

    <!-- Previously uploaded files -->
    <label
      [translatable]="{
        transKey: 'shared.previousAttachments',
        modEnum: translationModulesEnum.shared
      }"
      *ngIf="prevAttachment && prevAttachment.length !== 0"
    >
      {{ "shared.previousAttachments" | translate }}
    </label>
    <ul
      class="uploaded-files"
      *ngIf="prevAttachment && prevAttachment.length !== 0"
    >
      <li *ngFor="let file of prevAttachment; let i = index">
        <div class="file-details" *ngIf="file">
          <i [class]="'bx ' + 'bxs-file-' + file?.extension.split('.')[1]"></i>
          <div>
            <!--            <span class="name" [title]="file?.fileName">{{ file?.fileName?.split("_")[0] }}</span>-->
            <span class="name" [title]="file?.name">
              {{
                file?.fileName.length > 25
                  ? file?.fileName?.slice(0, 25).concat("...")
                  : file?.fileName
              }}
            </span>
          </div>
        </div>
        <!-- <button (click)="onDeleteFileFromCloud(file)" class="file-delete-btn">
          <i class="bx bx-trash"></i>
        </button> -->
        <button (click)="onViewFile(file)" class="file-view-btn">
          <i class="bx bx-show"></i>
        </button>
      </li>
    </ul>

    <!-- Upload File Button -->
    <div class="upload-file-btn" *ngIf="!disabled">
      <div
        [translatable]="{
          transKey: uploadFilesTitleTranslationKey,
          modEnum: uploadFilesTitleTranslationModuleEnum
        }"
      >
        <label for="input-file">
          {{ uploadFilesTitle }}
          <span *ngIf="IsAttachmentRequired" class="astrix-red">*</span>
        </label>
      </div>
      <span class="upload-hint">
        {{ "shared.maxFileSixe1" | translate }} {{ maxFileSizeInMB }}
        {{ "shared.maxFileSixe2" | translate }}
        <span *ngFor="let type of hintTypes; let last = last">
          {{ " " + (type | translate) }}
          <span *ngIf="!last">,</span>
        </span>
      </span>
      <p
        class="upload-hint"
        *ngIf="attachmentHint?.ar || attachmentHint?.en"
        style="margin-bottom: 0"
      >
        {{ lang == "ar" ? attachmentHint?.ar : attachmentHint?.en }}
      </p>
      <input
        (change)="onUploadFile($event)"
        id="input-file"
        type="file"
        [accept]="supportedType.join(',')"
        [disabled]="disabled"
      />
    </div>
  </div>
</div>
<app-validation
  *ngIf="(control?.dirty || isSubmitted) && control?.invalid"
  [control]="control"
></app-validation>
